import { TimelineMax, TweenMax } from 'gsap';
import { useAnimate } from '../utils';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import EFAdd from '@/components/UI/svg/Footer/Icon/EFAdd';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/');
const LINK_MAP: any = {
    us: [
        'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40548220174409',
        'https://us.ecoflow.com/products/delta-pro-double-voltage-hub?variant=40521719251017',
        'https://us.ecoflow.com/products/transfer-switch?variant=40516904222793',
    ],
    za: ['https://za.ecoflow.com/pages/portable-power-stations'],
    au: [`https://au.ecoflow.com/collections/portable-power-stations`, 'https://au.ecoflow.com/products/transfer-switch'],
    ca: ['/ca/smart-home-panel', '/ca/smart-home-panel-2'],
};

let sceneEnterB: any = null,
    sceneLeaveB: any = null;
export default function B(): JSX.Element {
    const { useLang, Link, useRouter, useState, useEffect, useRef } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const SHOW_TRANSFER_SWITCH = ['sa', 'za', 'au'].includes(locale);

    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    const [active, setActive] = useState(0);
    const video1Ref = useRef();
    const video2Ref = useRef();
    const [changeCount, setChangeCount] = useState(0);

    // 自动切换两次后不再切换
    const handlePlayEnd = () => {
        if (active === 0) {
            if (changeCount < 2) {
                setActive(1);
                setChangeCount(changeCount + 1);
                video2Ref.current.play();
            } else {
                video1Ref.current.play();
            }
        }
        if (active === 1) {
            if (changeCount < 2) {
                setActive(0);
                setChangeCount(changeCount + 1);
                video1Ref.current.play();
            } else {
                video2Ref.current.play();
            }
        }
    };

    const handleChangTab = (n: number) => {
        changeCount < 2 && setChangeCount(2);
        if (active === n) return;
        if (n === 0) {
            setActive(0);
            video1Ref.current.currentTime = 0;
            video1Ref.current.play();
        }
        if (n === 1) {
            setActive(1);
            video2Ref.current.currentTime = 0;
            video2Ref.current.play();
        }
    };

    const scrollToTS = () => {
        window.scrollTo({
            top: 1100,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        if (!IS_NA_SITES) {
            const { createScene, destroy } = useAnimate();

            createScene({
                triggerElement: '.landing_page_C',
                triggerHook: 1,
                offset: 100,
                duration: 500,
            })
                .setTween(
                    new TimelineMax().add(
                        TweenMax.to('.landingDesc', 1, {
                            opacity: 1,
                        }),
                        0,
                    ),
                )
                .addTo((window as any).aniController);

            createScene({
                triggerElement: '.videoBox',
                triggerHook: 1,
                offset: 200,
                duration: 600,
            })
                .setTween(
                    new TimelineMax()
                        .add(
                            TweenMax.to('.videoBox', 1, {
                                opacity: 1,
                            }),
                            0,
                        )
                        .add(
                            TweenMax.to('.powerInletBox', 1, {
                                opacity: 1,
                            }),
                            0,
                        ),
                )
                .addTo((window as any).aniController);

            return () => destroy();
        } else {
            if (typeof window !== 'undefined') {
                const resizeAni = () => {
                    if (sceneEnterB) {
                        AniContainer.removeScene(sceneEnterB);
                        sceneEnterB = null;
                    }
                    if (sceneLeaveB) {
                        AniContainer.removeScene(sceneLeaveB);
                        sceneLeaveB = null;
                    }
                    const videos = document.querySelector('.landing_page_C .videos') as HTMLUListElement;
                    if (videos) {
                        sceneEnterB = AniContainer.create({
                            triggerElement: '.landing_page_C .videos .video.active',
                            triggerHook: 1,
                            offset: videos?.offsetHeight / 2,
                            duration: window?.innerHeight - videos?.offsetHeight / 2,
                            onEnter: () => {
                                if (active === 0) {
                                    video1Ref.current.play();
                                }
                                if (active === 1) {
                                    video2Ref.current.play();
                                }
                            },
                        });

                        sceneLeaveB = AniContainer.create({
                            triggerElement: '.landing_page_C .videos .video.active',
                            triggerHook: 1,
                            offset: 0,
                            duration: window?.innerHeight + videos?.offsetHeight,
                            onLeave: () => {
                                if (active === 0) {
                                    video1Ref.current.pause();
                                    video1Ref.current.currentTime = 0;
                                }
                                if (active === 1) {
                                    video2Ref.current.pause();
                                    video2Ref.current.currentTime = 0;
                                }
                            },
                        });
                    }
                };
                resizeAni();
                //window.addEventListener('resize', resizeAni);
                return () => {
                    if (sceneEnterB) {
                        AniContainer.removeScene(sceneEnterB);
                        sceneEnterB = null;
                    }
                    if (sceneLeaveB) {
                        AniContainer.removeScene(sceneLeaveB);
                        sceneLeaveB = null;
                    }
                    // window.removeEventListener('resize', resizeAni);
                };
            }
        }
    }, []);

    return (
        <div className={`landing_page_C ${css.landing_page_C}`}>
            <div className="landingDesc">
                {/* https://${locale}.ecoflow.com/products/transfer-switch` */}
                {t.rich('secC_Content', {
                    link1: (text: string) => (
                        <Link className="linkText" href={LINK_MAP[locale][0] || ''}>
                            {text}{' '}
                        </Link>
                    ),
                    link2: (text: string) =>
                        ['za'].includes(locale) ? (
                            <span className="linkText" onClick={scrollToTS}>
                                {text}{' '}
                            </span>
                        ) : (
                            <Link className="linkText" href={LINK_MAP[locale][1] || ''}>
                                {text}{' '}
                            </Link>
                        ),
                    link3: (text: string) => (
                        <Link className="linkText" href={LINK_MAP[locale][2] || ''}>
                            {text}{' '}
                        </Link>
                    ),
                })}
            </div>
            {!IS_NA_SITES && (
                <div className="videoBox">
                    <div className="innerVideo">
                        {['sa', 'za'].includes(locale) && (
                            <EFVideo sources={['/video/landingPage/pc/landing_page_c2.mp4', '/video/landingPage/pc/landing_page_c2.mp4']} />
                        )}
                        {!['sa', 'za'].includes(locale) && (
                            <EFVideo sources={['/video/landingPage/pc/landing_page_c.webm', '/video/landingPage/pc/landing_page_c.mp4']} />
                        )}
                        <div className="powerInletBox">
                            <div className="powerInletBoxText">{t('secC_product_1')}</div>
                            <div className="powerInletBoxIcon">
                                <EFAdd />
                            </div>
                            <div className={`powerInletBoxCard ${SHOW_TRANSFER_SWITCH ? 'transfer-switch' : ''}`}>
                                {SHOW_TRANSFER_SWITCH && (
                                    <>
                                        <div className="transfer-switch-img">
                                            {/* // 南非断货，改图片 https://ecoflow.feishu.cn/docx/YLRadFfARoRxJwx7ADIcKtgXnPh */}
                                            <EFPic
                                                name={
                                                    locale === 'za'
                                                        ? ['transfer_switch_za.webp', 'transfer_switch_za.png']
                                                        : ['transfer_switch.webp', 'transfer_switch.png']
                                                }
                                            />
                                        </div>
                                        <div className="secB_product_text">
                                            <h5>{t('c_transfer_switch')}</h5>
                                            <p>
                                                {t.rich('c_transfer_switch_desc', {
                                                    link: (text: string) => (
                                                        <Link href={LINK_MAP[locale][0]} className="link-desc">
                                                            {text}
                                                        </Link>
                                                    ),
                                                })}
                                            </p>
                                        </div>
                                    </>
                                )}
                                {!SHOW_TRANSFER_SWITCH && (
                                    <>
                                        <div className="secB_product_text">
                                            <h5>{t('secC_product_1')}</h5>
                                            <p>{t('secC_product_desc_1')}</p>
                                        </div>
                                        <div className="secB_product_img">
                                            <EFPic className="product_img_1" name={['pc/c-1.webp', 'pc/c-1.jpg']} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {IS_NA_SITES && (
                <>
                    <ul className="videos">
                        <li className={`video ${active === 0 ? 'active' : ''}`}>
                            <video
                                ref={video1Ref}
                                src={`/responsive/video/delta-pro-ultra/launch/2_1.mp4`}
                                muted
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster="/responsive/picture/delta-pro-ultra/launch/2_1.jpg"
                                aria-label={t('secB_tab1')}
                                onEnded={handlePlayEnd}
                            />

                            <div className="float-msg">
                                <svg className="light-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6.93401 13.8007L10.2631 19.5668L10.8833 19.2087L0.62021 1.43259L0 1.79067L2.7367 6.53077L0.000196251 10.6528H3.76002L2.86483 20.5L6.93401 13.8007ZM7.73947 12.4747L3.57698 5.26502L7.07225 0L6.71417 8.41485H10.2054L7.73947 12.4747Z"
                                        fill="white"
                                    />
                                </svg>
                                <p className="icon-text">{t('secB_icon')}</p>
                            </div>
                        </li>
                        <li className={`video ${active === 1 ? 'active' : ''}`}>
                            <video
                                ref={video2Ref}
                                src={'/responsive/video/delta-pro-ultra/launch/2_2.mp4'}
                                muted
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster="/responsive/picture/delta-pro-ultra/launch/2_2.jpg"
                                aria-label={t('secB_tab2')}
                                onEnded={handlePlayEnd}
                            />
                        </li>
                    </ul>
                    <ul className="tabs">
                        <li className={`tab ${active === 0 ? 'active' : ''}`} onClick={() => handleChangTab(0)}>
                            {t('secB_tab1')}
                        </li>

                        <li className={`tab ${active === 1 ? 'active' : ''}`} onClick={() => handleChangTab(1)}>
                            {t('secB_tab2')}
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
}
